// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_ExtendResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_ExtendResponse — result of POST /subscriptions/extend.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_ExtendResponseDados {
success: boolean
subscription_id: number
new_grace_until: string
}

export type Subscriptions_ExtendResponse = ApiResponse<Subscriptions_ExtendResponseDados>;

registerResponseContract('Subscriptions_ExtendResponse', {
  success:         { type: 'boolean', required: true },
  subscription_id: { type: 'number',  required: false },
  new_grace_until: { type: 'string',  required: false },
})
